<script lang="ts">
import { defineComponent, reactive } from 'vue'
import stateInitializer from '@/models/stateInitializer'

export default defineComponent({
  name: 'SolutionHero',

  setup() {
    interface State {
      solution: Solution,
    }

    const state: State = reactive({
      solution: {
        id: undefined,
        title: '',
        logoImageUrl: '',
        backgroundImageUrl: '',
        description: '',
        company: {
          name: '',
        },
      },
    })

    stateInitializer(state, 'hero')

    return {
      // data
      state,
    }
  },
})
</script>

<template>
  <section class="f-section__hero">
    <div class="f-section__hero--body is-primary">
      <div class="l-unit__solutionIntroduction">
        <div class="l-unit__solutionIntroduction--header">
          <div class="o-heading__page">
            <h1 class="o-heading__page--item">
              {{ state.solution.title }}
            </h1>
          <!-- /.o-heading__page --></div>
        <!-- /.l-unit__solutionIntroduction header --></div>

        <div class="l-unit__solutionIntroduction--image">
          <img
            class="img"
            :src="state.solution.logoImageUrl"
            alt="">
        <!-- /.l-unit__solutionIntroduction image --></div>

        <div class="l-unit__solutionIntroduction--description">
          <div class="o-label__solutionIntroduction">
            <p class="o-label__solutionIntroduction--item">
              {{ state.solution.description }}
            </p>
          <!-- /.o-label__solutionIntroduction --></div>
        <!-- /.l-unit__solutionIntroduction description --></div>
      <!-- /.l-unit__solutionIntroduction --></div>
    <!-- /.f-section__hero body --></div>

    <div class="f-section__hero--body is-background">
      <div class="o-figure__background">
        <img
          class="o-figure__background--item"
          :src="state.solution.backgroundImageUrl"
          fetchpriority="high"
          alt="">
      <!-- /.o-figure__background --></div>
    <!-- /.f-section__hero body --></div>
  <!-- /.f-section__hero --></section>
</template>

<style lang="sass" scoped>
// foundation
.f-section__hero
  $root: &
  display: flex
  flex-direction: column
  background: linear-gradient(rgba($bg-white, 1) 80%, rgba($bg-x-light-gray, 1))

  & &--body
    &.is-primary
      padding: 0 24px

    &.is-background
      $image-width: $global-contents-width-pc
      $image-height: 240
      display: flex
      flex-direction: column
      justify-content: center
      order: -1
      position: relative
      overflow: hidden

      &::before
        content: ""
        width: 0
        height: 0
        display: block
        padding-top: getRelativeValue($image-height, $image-width)

  +breakpoint
    #{$root}--body
      &.is-primary
        margin-top: 1em

      &.is-background
        $image-width: 375
        $image-height: 90
        &::before
          padding-top: getRelativeValue($image-height, $image-width)

// layout
.l-unit__solutionIntroduction
  $root: &
  $logo-image-size: 96px
  $logo-image-adjust-top-position: -24px
  min-height: ($logo-image-size + $logo-image-adjust-top-position)
  display: flex
  flex-direction: column
  position: relative
  padding:
    top: 0.5em
    left: $logo-image-size

  & &--header,
  & &--description
    margin-left: 24px

  & &--image
    width: $logo-image-size
    height: $logo-image-size
    display: flex
    align-items: center
    justify-content: center
    position: absolute
    top: $logo-image-adjust-top-position
    left: 0
    overflow: hidden
    background-color: rgba($bg-white, 1)
    border: 1px solid $border-x-light-gray
    z-index: 1

    > .img
      height: 100%
      display: block
      object-fit: contain
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)

  +breakpoint
    min-height: $logo-image-size
    padding-top: 0

    #{$root}--image
      top: 0

// object
.o-heading__page
  & &--item
    line-height: 1.6
    font:
      size: $font-x-huge
      weight: bold

.o-label__solutionIntroduction
  & &--item
    line-height: 1.6
    color: $font-xx-dark-gray
    font-size: $font-small

.o-figure__background
  width: 100%
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  margin: 0 auto
</style>
